<template>
	<header-menu-admin />
	
	<!-- Main Sections -->
	<main class="main-wrapper bg-lightest-gray">

		<!-- About Section Start -->
		<section class="about-section py-40">
			<div class="container-fluid">
				<div class="top-bar mb-16">
					<router-link :to="{path: '/admin/products-categories'}" class="btn btn-secondary">
						Назад
					</router-link>
				</div>
				<div class="about-wrapper bg-white">
					<div class="about-block">
						<h4 class="mb-12">Добавление категории товаров</h4>
						<form @submit.prevent="onProductsCategoryAdd" class="contact-form">
							<div class="row">
								<div class="col-md-1">
									<div class="input-block mb-16">
										<label for="parent_id" class="form-label">Родит. ID:</label>
										<input type="number" id="parent_id" @wheel="$event.target.blur()" class="form-control noscroll" min="1" v-model="parent_id">
									</div>
								</div>
								<div class="col-md-11">
									<div class="input-block mb-16">
										<label for="name" class="form-label">Название:</label>
										<input type="text" id="name" class="form-control" placeholder="Название" v-model="name" required>
									</div>
								</div>
								<div class="col-md-12">
									<button type="submit" class="btn btn-primary" :disabled="btnDisabled">Добавить</button>
								</div>
							</div>
						</form>
						<div class="alert alert-warning alert-dismissible mt-3 mb-0" role="alert" v-if="error">
							{{error}}
							<button type="button" class="btn-close" aria-label="Close" @click="error = ''"></button>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- About Section End -->
	</main>
	<!-- Main Sections -->
</template>

<style lang="scss">
      
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import HeaderMenuAdmin from '@/components/HeaderMenuAdmin';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'InterMagTech Admin'});
	},
	data: () => ({
		parent_id: '',
		name: '',
		
		loading: true,
		error: '',
		btnDisabled: false,
	}),
	methods: {
		async onProductsCategoryAdd(){
			this.error = '';
			this.btnDisabled = true;
			
			const params = {
				name: this.name,
			};
			if(this.parent_id){
				params['parent_id'] = this.parent_id;
			}
			let ret = await this.appModel.doAddProductsCategory(params);
			this.btnDisabled = false;
			if(ret.success){
				ret = await this.appModel.doGetProductsCategories();
				if(ret.success) {
					this.appModel.productsCategories = ret.list;
				}
				
				this.$router.push('/admin/products-categories');
			} else {
				this.error = ret.error;
			}
		},
	},
	mounted(){
		window.scrollTo(0, 0);
	},
	beforeRouteUpdate(to, from, next){
		window.scrollTo(0, 0);
		next();
	},
	components: {
		HeaderMenuAdmin,
	},
};
</script>